export default class SeriesInfo {
    DataPageInstance;
    pageSlug;
    //
    button;
    //
    contentWrapper;
    //
    // <span class="js-series-info-scroll-anchor absolute top-0 left-0 block -translate-y-header-offset pointer-events-none"></span>
    template = `<div class="data-page__name"><strong>Page:</strong> {{data_page}}</div>
                       <div class="data-page__date-range"><strong>Date Range:</strong> {{start_date}} - {{end_date}}</div>
                       <div class="data-page__geography"><strong>Geography:</strong> {{geography}}</div>
                       <div class="data-page__geography-type"><strong>Geo Type:</strong> {{geography_type}}</div>
                       <div class="data-page__source"><strong>Source:</strong> {{source}}</div>`;

    constructor(DataPageInstance, pageSlug) {
        this.DataPageInstance = DataPageInstance;
        this.pageSlug = pageSlug;
        //
        this.initializeHTMLElements();
        //
        this.registerEvents();
    }

    initializeHTMLElements() {
        this.button = document.querySelector('.js-series-info');
        this.contentWrapper = document.querySelector(
            '.js-series-info-content-wrapper',
        );
    }

    registerEvents() {
        if (this.button) {
            this.button.addEventListener(
                'click',
                this.clickEventHandler.bind(this),
            );
        }
    }

    clickEventHandler() {
        const pageSlug = this.pageSlug;
        const geoData = this.getGeoRequestParams();

        // Trigger Custom Event RequestStart.
        this.eventRequestStart();

        //
        let request = {
            pageSlug: pageSlug,
            geoData: geoData,
        };
        // console.log(request);

        this.sendRequest(request);
    }

    sendRequest(request) {
        fetch(
            `${window.location.origin}/wp-json/trerc-data/v1/dp-series-info`,
            {
                method: 'post',
                body: JSON.stringify(request),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            },
        )
            .then((httpResponse) => httpResponse.json())
            .then((response) => {
                const rez = JSON.parse(response);

                if (rez.status === 'success') {
                    this.responseSuccess(rez);
                } else {
                    this.responseError(rez);
                }
            })
            .catch(this.responseError.bind(this));
    }

    responseSuccess(rez) {
        const data = rez.data;
        // console.log(rez);

        // Clear previous content.
        this.contentWrapper.innerHTML = '';
        //
        let element = this.template;

        //
        Object.keys(data).forEach((key) => {
            const value = data[key];
            element = element.replace(new RegExp(`{{${key}}}`, 'g'), value);
        });

        // Add new template element and show.
        this.contentWrapper.innerHTML = element;
        this.contentWrapper.classList.remove('hidden');

        //
        // this.scrollIntoView();

        // Trigger Custom Event RequestEnd.
        this.eventRequestEnd('success', rez);
    }

    responseError(response) {
        // console.error(response);

        this.hideWrapper();

        alert(
            'Unfortunately something went wrong! Please contact us for more information!',
        );

        // Trigger Custom Event RequestEnd.
        this.eventRequestEnd('error', {});
    }

    hideWrapper() {
        if (!this.contentWrapper) {
            return;
        }
        this.contentWrapper.innerHTML = '';
        this.contentWrapper.classList.add('hidden');
    }

    btnAvailability(visible) {
        if (!this.button) {
            return;
        }
        const el = this.button;
        //
        if (visible) {
            el.classList.remove('!hidden');
        } else {
            el.classList.add('!hidden');
        }
    }

    getGeoRequestParams() {
        return this.DataPageInstance.getGeoRequestParams();
    }

    scrollIntoView() {
        const anchor = document.querySelector('.js-series-info-scroll-anchor');
        if (anchor) {
            // Scroll to the top of the block
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    /**
     * Dispatch a custom event to signal the start of a request.
     */
    eventRequestStart() {
        const event = new CustomEvent('seriesInfoRequest.Start');
        document.dispatchEvent(event);
    }

    /**
     * Dispatch a custom event to signal the end of a request.
     * @param {string} type - The type of the request (success or error).
     * @param {Object} data - Data associated with the request.
     */
    eventRequestEnd(type, data = {}) {
        const event = new CustomEvent('seriesInfoRequest.End', {
            bubbles: true,
            detail: {
                type: type,
                data: data,
            },
        });
        document.dispatchEvent(event);
    }
}
